/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Decimal = z.number();

export type Decimal = z.infer<typeof Decimal>;
